module.exports = __webpack_public_path__ + "static/media/pg26.05d485b7.jpg";